import { useEffect, useState } from "react";
import { fetchFromApi } from "../helpers/fetchFromApi";

export default function LeagueContextPreview({ onHome }) {
  const [html, setHtml] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    fetchFromApi("league-context-preview", { expectedResponse: "league-preview-html" }).then(async response => {
      if (!response.ok) throw new Error(response.status === 403 ? "Diese Vorschau ist nur für den Betreiber-Admin freigegeben." : response.status === 401 ? "Bitte mit deinem bestehenden betty-Account anmelden." : "Vorschau derzeit nicht verfügbar.");
      if (!response.headers.get("content-type")?.includes("text/html")) throw new Error("Ungültige Vorschau-Antwort.");
      const text = await response.text();
      if (active) setHtml(text);
    }).catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, []);
  return <div style={{background:"#09131e",color:"#e4edf5",minHeight:"100vh"}}>
    <div style={{padding:"10px 20px",display:"flex",gap:20,alignItems:"center"}}>
      <button onClick={onHome}>Zurück zu betty</button>
      <strong>Liga-Kontext · Geschützte Vorschau</strong>
      <span>Gespeicherter Entwurf · keine Änderungen an Produktionsdaten</span>
    </div>
    {error ? <p role="alert" style={{padding:20}}>{error}</p> : !html ? <p role="status">Vorschau wird geladen …</p> : <iframe title="Liga-Kontext Vorschau" sandbox="allow-scripts" referrerPolicy="no-referrer" srcDoc={html} style={{width:"100%",height:"calc(100vh - 56px)",border:0,display:"block"}} />}
  </div>;
}
